import React from 'react';

const PAYMENT_METHOD_ICON = {
  FPTPAY_DOMESTIC: 'fa-university',
  FPTPAY_INTERNATIONAL: 'fa-credit-card',
  FPTPAY_VIETQR: 'fa-qrcode',
};

export function getPaymentMethodIcon(code = '') {
  return PAYMENT_METHOD_ICON[code] || 'fa-money';
}

export function PaymentMethodCard({ paymentMethod, onSelect }) {
  const {
    payment_method_name: title,
    description,
    payment_method_img,
    payment_method_code,
    id,
  } = paymentMethod;

  return (
    <button
      type="button"
      className="pay-method-card"
      onClick={() => onSelect(id)}
    >
      <span className="pay-method-card__content">
        <span className="pay-method-card__title">{title}</span>
        {description && (
          <span className="pay-method-card__subtitle">{description}</span>
        )}
      </span>
      <span className="pay-method-card__logo">
        {payment_method_img ? (
          <img
            src={payment_method_img}
            alt={title}
            className="pay-method-card__img"
          />
        ) : (
          <i
            className={`fa ${getPaymentMethodIcon(payment_method_code)}`}
            aria-hidden="true"
          />
        )}
      </span>
    </button>
  );
}

export default function PaymentMethodList({
  paymentMethodData,
  onSelect,
  title = 'Chọn phương thức thanh toán',
  intro,
  note = 'Lưu ý: Không tắt trình duyệt trong quá trình thanh toán.',
  deadlineText,
  className = 'pay-method-modal',
}) {
  const methods = Object.values(paymentMethodData || {}).flat();

  return (
    <div className={className}>
      <h4 className="pay-method-modal__title">{title}</h4>
      {intro && <p className="pay-method-modal__intro">{intro}</p>}
      {note && <p className="pay-method-modal__note">{note}</p>}

      <div className="pay-method-list">
        {methods.map((paymentMethod) => (
          <PaymentMethodCard
            key={paymentMethod.id}
            paymentMethod={paymentMethod}
            onSelect={onSelect}
          />
        ))}
      </div>

      {deadlineText && (
        <p className="pay-method-modal__deadline">{deadlineText}</p>
      )}
    </div>
  );
}
